import * as tslib_1 from "tslib";
import { ContentContainer } from './content_container';
var Model = /** @class */ (function (_super) {
    tslib_1.__extends(Model, _super);
    function Model(param) {
        return _super.call(this, param) || this;
    }
    Model.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "Model" });
    };
    Model.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Model;
}(ContentContainer));
export { Model };
//# sourceMappingURL=model.js.map